import { render, staticRenderFns } from "./UpgradePlanSection.vue?vue&type=template&id=0ad10556&scoped=true"
import script from "./UpgradePlanSection.vue?vue&type=script&lang=js"
export * from "./UpgradePlanSection.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlanSection.vue?vue&type=style&index=0&id=0ad10556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad10556",
  null
  
)

export default component.exports